
import "../styles/main.scss"
import React, { useState } from 'react';
import TestDriveForm from '../components/TestDriveForm';
import alpineLogo from '../assets/alpine-logo-lettres.png';

const quizQuestions = [
    {
        question: "Quelle est l'année d'ouverture de l'Alpine Store La Rochelle ?",
        options: ["2017", "2018", "2019"],
        correctIndex: 1
    },
    {
        question: "Où sont aujourd'hui fabriqués les modèles Alpine A110 ?",
        options: ["Le Mans", "Flins", "Dieppe"],
        correctIndex: 2
    },
    {
        question: "Quel était le métier de Jean Rédélé avant de fonder Alpine ?",
        options: ["Ingénieur moteur", "Pilote professionnel", "Concessionnaire Renault"],
        correctIndex: 2
    },
    {
        question: "Quel pilote a remporté le Rallye de Monte-Carlo 1971 au volant d'une Alpine A110 ?",
        options: ["Jean-Luc Thérier", "Ove Andersson", "Bernard Darniche"],
        correctIndex: 1
    },
    {
        question: "En endurance, sous quel nom Alpine est-elle engagée en Hypercar au Mans ?",
        options: ["Alpine Racing", "Alpine Motorsport", "Alpine Endurance Team"],
        correctIndex: 2
    },
    {
        question: "Quel matériau est principalement utilisé pour le châssis et la carrosserie de l'A110 actuelle ?",
        options: ["Acier", "Fibre de carbone", "Aluminium"],
        correctIndex: 2
    },
    {
        question: "Quel est le principal atout de l'Alpine A290 ?",
        options: ["La puissance", "L'autonomie", "L'agilité"],
        correctIndex: 2
    },
    {
        question: "Quelle est l'autonomie de la nouvelle Alpine A390 ?",
        options: [
            "Jusqu'à 455 km (WLTP)",
            "Jusqu'à 555 km (WLTP)",
            "Jusqu'à 655 km (WLTP)"
        ],
        correctIndex: 1
    },
    {
        question: "Combien pèse une Alpine A110 ?",
        options: ["Environ 980 kg", "Environ 1 100 kg", "Environ 1 250 kg"],
        correctIndex: 1
    },
    {
        question: "Combien de Cars & Coffee ont été organisés depuis l'ouverture de l'Alpine Store La Rochelle ?",
        options: ["18", "20", "23"],
        correctIndex: 2
    }
];

export default function Tablet() {
    const [showForm, setShowForm] = useState(false);
    const [showQuiz, setShowQuiz] = useState(false);
    const [showFiches, setShowFiches] = useState(false);
    const [participant, setParticipant] = useState({ nom: "", prenom: "" });
    const [quizStep, setQuizStep] = useState("identity"); // 'identity' | 'questions' | 'result'
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [answers, setAnswers] = useState(Array(quizQuestions.length).fill(null));
    const [score, setScore] = useState(0);
    const [errorMessage, setErrorMessage] = useState("");
    const [isSavingResult, setIsSavingResult] = useState(false);
    const [saveError, setSaveError] = useState("");

    // Fiches techniques PDF
    const fichesTechniques = [
        { nom: "Alpine A110", pdf: "/brochures/A110 BROCHURE PRODUIT.pdf" },
        { nom: "Alpine A290", pdf: "/brochures/A290 BROCHURE PRODUIT.pdf" },
        { nom: "Alpine A390", pdf: "/brochures/A390 BROCHURE PRODUIT.pdf" }
    ];

    const resetQuiz = () => {
        setParticipant({ nom: "", prenom: "" });
        setQuizStep("identity");
        setCurrentQuestionIndex(0);
        setAnswers(Array(quizQuestions.length).fill(null));
        setScore(0);
        setErrorMessage("");
        setIsSavingResult(false);
        setSaveError("");
    };

    const handleCardClick = (type) => {
        switch(type) {
            case 'fiche-technique':
                setShowFiches(true);
                break;
            case 'configurateur':
                window.open('https://www.alpinecars.fr/modeles-electriques/a390/pre-configurator.html', '_blank');
                break;
            case 'quiz':
                resetQuiz();
                setShowQuiz(true);
                break;
            case 'essai':
                setShowForm(true);
                break;
            default:
                break;
        }
    };

    const handleOpenPdf = (pdfUrl) => {
        window.open(pdfUrl, '_blank', 'noopener,noreferrer');
    };

    const handleParticipantChange = (event) => {
        const { name, value } = event.target;
        setParticipant((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleStartQuiz = (event) => {
        event.preventDefault();
        const nom = participant.nom.trim();
        const prenom = participant.prenom.trim();

        if (!nom || !prenom) {
            setErrorMessage("Merci de renseigner votre nom et votre prénom pour commencer le quiz.");
            return;
        }

        setErrorMessage("");
        setQuizStep("questions");
        setCurrentQuestionIndex(0);
    };

    const handleNextQuestion = async (event) => {
        event.preventDefault();

        if (answers[currentQuestionIndex] === null) {
            setErrorMessage("Merci de sélectionner une réponse pour continuer.");
            return;
        }

        setErrorMessage("");

        const isLastQuestion = currentQuestionIndex === quizQuestions.length - 1;

        if (isLastQuestion) {
            const calculatedScore = answers.reduce((total, answerIndex, index) => {
                if (answerIndex === quizQuestions[index].correctIndex) {
                    return total + 1;
                }
                return total;
            }, 0);

            setScore(calculatedScore);

            // Enregistrer le résultat côté serveur pour le backoffice
            const totalQuestions = quizQuestions.length;
            const percentage = Math.round((calculatedScore / totalQuestions) * 100);

            try {
                setIsSavingResult(true);
                setSaveError("");

                const apiUrl = process.env.NODE_ENV === 'production'
                    ? '/api/quiz-results'
                    : 'http://localhost:5000/api/quiz-results';

                const answersDetail = answers.map((answerIndex, index) => ({
                    questionIndex: index,
                    correct: answerIndex === quizQuestions[index].correctIndex,
                }));

                const response = await fetch(apiUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        nom: participant.nom.trim(),
                        prenom: participant.prenom.trim(),
                        score: calculatedScore,
                        totalQuestions,
                        percentage,
                        answers: answersDetail,
                    }),
                });

                if (!response.ok) {
                    throw new Error(`Erreur HTTP ${response.status}`);
                }
            } catch (error) {
                console.error("Erreur lors de l'enregistrement du résultat du quiz :", error);
                setSaveError("Le résultat n'a pas pu être enregistré. Il sera néanmoins affiché ci-dessous.");
            } finally {
                setIsSavingResult(false);
                setQuizStep("result");
            }
        } else {
            setCurrentQuestionIndex((prevIndex) => prevIndex + 1);
        }
    };

    const handleCloseQuiz = () => {
        setShowQuiz(false);
        resetQuiz();
    };

    const currentQuestion = quizStep === "questions"
        ? quizQuestions[currentQuestionIndex]
        : null;
    const currentAnswer = quizStep === "questions"
        ? answers[currentQuestionIndex]
        : null;

    return (
        <div className="tablet-page">
            <div className="tablet-header">
                <div className="tablet-header__brand">
                    <img src={alpineLogo} alt="Alpine" className="tablet-header__logo" />
                    <span className="tablet-header__store">Store La Rochelle</span>
                </div>
                <h1>LANCEMENT</h1>
                <h2>A390</h2>
            </div>
            
            <div className="tablet-grid">
                <div 
                    className="tablet-card" 
                    onClick={() => handleCardClick('fiche-technique')}
                >
                    <div className="tablet-card__image">
                        <img src="/images/tablet/FICHES PRODUITS.jpg" alt="Fiches techniques" />
                    </div>
                    <div className="tablet-card__overlay">
                        <h3>Fiches techniques</h3>
                    </div>
                </div>

                <div 
                    className="tablet-card" 
                    onClick={() => handleCardClick('configurateur')}
                >
                    <div className="tablet-card__image">
                        <img src="/images/tablet/CONFIGURATEUR.jpg" alt="Configurateur" />
                    </div>
                    <div className="tablet-card__overlay">
                        <h3>Configurateur</h3>
                    </div>
                </div>

                <div 
                    className="tablet-card" 
                    onClick={() => handleCardClick('quiz')}
                >
                    <div className="tablet-card__image">
                        <img src="/images/tablet/QUIZZ ALPINE.JPG" alt="Quiz Alpine" />
                    </div>
                    <div className="tablet-card__overlay">
                        <h3>Quiz</h3>
                    </div>
                </div>

                <div 
                    className="tablet-card" 
                    onClick={() => handleCardClick('essai')}
                >
                    <div className="tablet-card__image">
                        <img src="/images/tablet/FORMULAIRE ESSAI.jpg" alt="Demande d'essai" />
                    </div>
                    <div className="tablet-card__overlay">
                        <h3>Demande d'essai</h3>
                    </div>
                </div>
            </div>

            {showFiches && (
                <div className="test-drive-modal" onClick={() => setShowFiches(false)}>
                    <div
                        className="test-drive-modal__content test-drive-modal__content--fiches"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            className="test-drive-modal__close"
                            onClick={() => setShowFiches(false)}
                        >
                            ×
                        </button>

                        <h2>Fiches techniques</h2>
                        <p>Sélectionnez un modèle pour consulter sa fiche technique.</p>

                        <div className="fiches-buttons">
                            {fichesTechniques.map((fiche, index) => (
                                <button
                                    key={index}
                                    type="button"
                                    className="fiche-btn"
                                    onClick={() => handleOpenPdf(fiche.pdf)}
                                >
                                    {fiche.nom}
                                </button>
                            ))}
                        </div>

                        <div className="test-drive-form__actions">
                            <button
                                type="button"
                                className="test-drive-form__cancel"
                                onClick={() => setShowFiches(false)}
                            >
                                Fermer
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {showForm && (
                <TestDriveForm onClose={() => setShowForm(false)} />
            )}

            {showQuiz && (
                <div className="test-drive-modal" onClick={handleCloseQuiz}>
                    <div
                        className="test-drive-modal__content"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            className="test-drive-modal__close"
                            onClick={handleCloseQuiz}
                        >
                            ×
                        </button>

                        {quizStep === "identity" && (
                            <>
                                <h2>Quiz Inauguration Alpine Store La Rochelle</h2>
                                <p>Merci de renseigner vos informations pour accéder au quiz.</p>

                                {errorMessage && (
                                    <div className="test-drive-modal__error">
                                        <p>{errorMessage}</p>
                                    </div>
                                )}

                                <form
                                    onSubmit={handleStartQuiz}
                                    className="test-drive-form"
                                >
                                    <div className="test-drive-form__group">
                                        <label htmlFor="quiz-nom">Nom *</label>
                                        <input
                                            type="text"
                                            id="quiz-nom"
                                            name="nom"
                                            value={participant.nom}
                                            onChange={handleParticipantChange}
                                            required
                                        />
                                    </div>

                                    <div className="test-drive-form__group">
                                        <label htmlFor="quiz-prenom">Prénom *</label>
                                        <input
                                            type="text"
                                            id="quiz-prenom"
                                            name="prenom"
                                            value={participant.prenom}
                                            onChange={handleParticipantChange}
                                            required
                                        />
                                    </div>

                                    <div className="test-drive-form__actions">
                                        <button
                                            type="button"
                                            className="test-drive-form__cancel"
                                            onClick={handleCloseQuiz}
                                        >
                                            Annuler
                                        </button>
                                        <button
                                            type="submit"
                                            className="test-drive-form__submit"
                                        >
                                            Commencer le quiz
                                        </button>
                                    </div>
                                </form>
                            </>
                        )}

                        {quizStep === "questions" && currentQuestion && (
                            <>
                                <h2>Quiz Inauguration Alpine Store La Rochelle</h2>
                                <p>
                                    Question {currentQuestionIndex + 1} / {quizQuestions.length}
                                </p>

                                {errorMessage && (
                                    <div className="test-drive-modal__error">
                                        <p>{errorMessage}</p>
                                    </div>
                                )}

                                <form
                                    onSubmit={handleNextQuestion}
                                    className="test-drive-form"
                                >
                                    <div className="test-drive-form__group">
                                        <p className="quiz-question-text">{currentQuestion.question}</p>
                                        <div className="quiz-options">
                                            {currentQuestion.options.map((option, index) => (
                                                <button
                                                    key={index}
                                                    type="button"
                                                    className={`quiz-option-btn ${currentAnswer === index ? 'quiz-option-btn--selected' : ''}`}
                                                    onClick={() => {
                                                        setAnswers((prev) => {
                                                            const next = [...prev];
                                                            next[currentQuestionIndex] = index;
                                                            return next;
                                                        });
                                                        setErrorMessage('');
                                                    }}
                                                >
                                                    <span className="quiz-option-btn__letter">{['A', 'B', 'C'][index]}</span>
                                                    <span className="quiz-option-btn__text">{option}</span>
                                                </button>
                                            ))}
                                        </div>
                                    </div>

                                    <div className="test-drive-form__actions">
                                        <button
                                            type="button"
                                            className="test-drive-form__cancel"
                                            onClick={handleCloseQuiz}
                                        >
                                            Abandonner
                                        </button>
                                        <button
                                            type="submit"
                                            className="test-drive-form__submit"
                                        >
                                            {currentQuestionIndex === quizQuestions.length - 1
                                                ? "Voir le résultat"
                                                : "Question suivante"}
                                        </button>
                                    </div>
                                </form>
                            </>
                        )}

                        {quizStep === "result" && (
                            <>
                                <h2>Résultat du quiz</h2>

                                {saveError && (
                                    <div className="test-drive-modal__error">
                                        <p>{saveError}</p>
                                    </div>
                                )}

                                <p>
                                    {participant.prenom} {participant.nom}, vous avez obtenu{" "}
                                    <strong>
                                        {score} / {quizQuestions.length}
                                    </strong>
                                    .
                                </p>
                                <p>
                                    Soit{" "}
                                    <strong>
                                        {Math.round(
                                            (score / quizQuestions.length) * 100
                                        )}
                                        % de bonnes réponses
                                    </strong>
                                    .
                                </p>

                                <div className="test-drive-form__actions">
                                    <button
                                        type="button"
                                        className="test-drive-form__cancel"
                                        onClick={handleCloseQuiz}
                                    >
                                        Fermer
                                    </button>
                                    {isSavingResult && (
                                        <button
                                            type="button"
                                            className="test-drive-form__submit"
                                            disabled
                                        >
                                            Enregistrement...
                                        </button>
                                    )}
                                </div>
                            </>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}
